export const analyticsEvents = {
  emailCodeRequested: "email_code_requested",
  emailCodeRequestFailed: "email_code_request_failed",
  emailAuthCompleted: "email_auth_completed",
  emailAuthFailed: "email_auth_failed",
  phoneCodeRequested: "phone_code_requested",
  phoneCodeRequestFailed: "phone_code_request_failed",
  phoneAuthCompleted: "phone_auth_completed",
  phoneAuthFailed: "phone_auth_failed",
  playerProfileCompleted: "player_profile_completed",
  hostEventCreated: "host_event_created",
  hostEventUpdated: "host_event_updated",
  hostEventDeleted: "host_event_deleted",
  lcGameCreated: "lc_game_created",
  lcGameStatusChanged: "lc_game_status_changed",
  lcConfigSaved: "lc_config_saved",
  lcTeamCreatedByHost: "lc_team_created_by_host",
  lcTeamRenamedByHost: "lc_team_renamed_by_host",
  lcTeamDeletedByHost: "lc_team_deleted_by_host",
  lcTeamsMergedByHost: "lc_teams_merged_by_host",
  lcRoundCreated: "lc_round_created",
  lcRoundStarted: "lc_round_started",
  lcRoundCompleted: "lc_round_completed",
  lcRoundDeleted: "lc_round_deleted",
  lcDecadesAssignedByHost: "lc_decades_assigned_by_host",
  lcScoreSavedByHost: "lc_score_saved_by_host",
  lcMagicNumberOverriddenByHost: "lc_magic_number_overridden_by_host",
  lcExtraBurnAddedByHost: "lc_extra_burn_added_by_host",
  lcMagicNumbersResetByHost: "lc_magic_numbers_reset_by_host",
  lcFinalStandingsRevealedByHost: "lc_final_standings_revealed_by_host",
} as const

export type AnalyticsEventName =
  (typeof analyticsEvents)[keyof typeof analyticsEvents]

export type AnalyticsProperties = Record<
  string,
  string | number | boolean | null | undefined
>
